import * as React from "react";

import { createSvgIcon } from "@mui/material/utils";

const Achievement13Icon = createSvgIcon(
    <svg
        width="160"
        height="160"
        viewBox="0 0 160 160"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M77.214 6.70423C78.7659 5.19787 81.2341 5.19787 82.786 6.70423L107.397 30.5925C107.871 31.0535 108.453 31.3894 109.09 31.5701L142.083 40.9394C144.163 41.5302 145.398 43.6677 144.869 45.7649L136.486 79.0224C136.325 79.6641 136.325 80.3359 136.486 80.9776L144.869 114.235C145.398 116.332 144.163 118.47 142.083 119.061L109.09 128.43C108.453 128.611 107.871 128.947 107.397 129.407L82.786 153.296C81.2341 154.802 78.7659 154.802 77.214 153.296L52.6034 129.407C52.1286 128.947 51.5468 128.611 50.9101 128.43L17.917 119.061C15.8365 118.47 14.6024 116.332 15.131 114.235L23.5136 80.9776C23.6753 80.3359 23.6753 79.6641 23.5136 79.0224L15.131 45.7649C14.6024 43.6677 15.8365 41.5302 17.917 40.9394L50.9101 31.5701C51.5468 31.3894 52.1286 31.0535 52.6034 30.5925L77.214 6.70423Z"
            fill="url(#paint0_linear_5305_1646)"
        />
        <path
            d="M77.214 6.70423C78.7659 5.19787 81.2341 5.19787 82.786 6.70423L107.397 30.5925C107.871 31.0535 108.453 31.3894 109.09 31.5701L142.083 40.9394C144.163 41.5302 145.398 43.6677 144.869 45.7649L136.486 79.0224C136.325 79.6641 136.325 80.3359 136.486 80.9776L144.869 114.235C145.398 116.332 144.163 118.47 142.083 119.061L109.09 128.43C108.453 128.611 107.871 128.947 107.397 129.407L82.786 153.296C81.2341 154.802 78.7659 154.802 77.214 153.296L52.6034 129.407C52.1286 128.947 51.5468 128.611 50.9101 128.43L17.917 119.061C15.8365 118.47 14.6024 116.332 15.131 114.235L23.5136 80.9776C23.6753 80.3359 23.6753 79.6641 23.5136 79.0224L15.131 45.7649C14.6024 43.6677 15.8365 41.5302 17.917 40.9394L50.9101 31.5701C51.5468 31.3894 52.1286 31.0535 52.6034 30.5925L77.214 6.70423Z"
            fill="url(#paint1_linear_5305_1646)"
        />
        <g filter="url(#filter0_i_5305_1646)">
            <path
                d="M77.214 22.7042C78.7659 21.1979 81.2341 21.1979 82.786 22.7042L101.477 40.8463C101.951 41.3072 102.533 41.6431 103.17 41.8239L128.227 48.9394C130.307 49.5302 131.541 51.6677 131.013 53.7649L124.646 79.0224C124.485 79.6641 124.485 80.3359 124.646 80.9776L131.013 106.235C131.541 108.332 130.307 110.47 128.227 111.061L103.17 118.176C102.533 118.357 101.951 118.693 101.477 119.154L82.786 137.296C81.2341 138.802 78.7659 138.802 77.214 137.296L58.5234 119.154C58.0486 118.693 57.4668 118.357 56.8301 118.176L31.7734 111.061C29.6929 110.47 28.4588 108.332 28.9874 106.235L35.3536 80.9776C35.5153 80.3359 35.5153 79.6641 35.3536 79.0224L28.9874 53.7649C28.4588 51.6677 29.6929 49.5302 31.7734 48.9394L56.8301 41.8239C57.4668 41.6431 58.0486 41.3072 58.5234 40.8463L77.214 22.7042Z"
                fill="url(#paint2_linear_5305_1646)"
            />
        </g>
        <path
            d="M78.2588 23.7803C79.1681 22.8978 80.5806 22.843 81.5527 23.6152L81.7412 23.7803L100.432 41.9229C101.003 42.4774 101.687 42.9005 102.436 43.1641L102.76 43.2666L127.816 50.3818C129.035 50.728 129.79 51.9243 129.607 53.1523L129.558 53.3984L123.192 78.6553C122.998 79.4274 122.973 80.2317 123.119 81.0117L123.192 81.3447L129.558 106.602C129.867 107.83 129.209 109.081 128.055 109.537L127.816 109.617V109.618L102.76 116.733C101.994 116.951 101.286 117.331 100.684 117.848L100.432 118.077L81.7412 136.22C80.8319 137.102 79.4194 137.157 78.4473 136.385L78.2588 136.22L59.5684 118.077C58.997 117.523 58.313 117.1 57.5645 116.836L57.2402 116.733L32.1836 109.618V109.617C30.9646 109.271 30.2099 108.076 30.3926 106.848L30.4424 106.602L36.8076 81.3447C37.0022 80.5726 37.0268 79.7683 36.8809 78.9883L36.8076 78.6562L30.4424 53.3984C30.1327 52.1698 30.7906 50.9189 31.9453 50.4629L32.1836 50.3818L57.2402 43.2666C58.0059 43.0491 58.714 42.6686 59.3164 42.1523L59.5684 41.9229L78.2588 23.7803Z"
            stroke="#AEAEAE"
            strokeWidth="3"
        />
        <g filter="url(#filter1_d_5305_1646)">
            <path
                d="M80 48L100 64V80V96L80 112L60 96V80V64L80 48Z"
                fill="url(#paint3_linear_5305_1646)"
            />
            <path
                d="M80 48L100 64M80 48L60 64M80 48V64M80 112L60 96M80 112L100 96M80 112V96M100 64V80V96M100 64L89.0909 72.4211M60 64V80V96M60 64L70.9091 72.4211M60 96L70.9091 87.5789M100 96L89.0909 87.5789M70.9091 72.4211V87.5789M70.9091 72.4211L80 64M70.9091 87.5789L80 96M89.0909 72.4211V87.5789M89.0909 72.4211L80 64M89.0909 87.5789L80 96"
                stroke="#E9E6E4"
                strokeWidth="1.5"
            />
        </g>
        <defs>
            <filter
                id="filter0_i_5305_1646"
                x="28.8652"
                y="21.5745"
                width="106.27"
                height="120.851"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="4" dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_5305_1646"
                />
            </filter>
            <filter
                id="filter1_d_5305_1646"
                x="59.25"
                y="43.0396"
                width="49.5"
                height="73.9209"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_5305_1646"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_5305_1646"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_5305_1646"
                x1="4"
                y1="4"
                x2="156"
                y2="159.8"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FBE865" />
                <stop offset="1" stopColor="#F1A718" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_5305_1646"
                x1="4"
                y1="4"
                x2="156"
                y2="159.8"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FFF7EF" />
                <stop offset="1" stopColor="#D5D4D3" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_5305_1646"
                x1="20"
                y1="20"
                x2="140"
                y2="140"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F4F4F4" />
                <stop offset="1" stopColor="#CEC5C0" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_5305_1646"
                x1="109.091"
                y1="112"
                x2="43.5184"
                y2="56.7756"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#3A50C1" />
                <stop offset="1" stopColor="#8199E6" />
            </linearGradient>
        </defs>
    </svg>,
    "Achievement13Icon",
);

export default Achievement13Icon;
